var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('column-container',[_c('padded-content',{staticClass:"space-children-inline-wide"},[_c('tabbed-nav',{staticClass:"tabbed-nav",attrs:{"buttons":_vm.tabButtons,"selected-key":_vm.currentTabKey,"with-pin-line":""}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }